import { Description, Title } from "@radix-ui/react-dialog";
import { Body } from "../../body/Body";
import { Heading } from "../../heading/Heading";
import { Props, Wrapper } from "./ModalHead.Parts";

export const ModalHead = ({
  title,
  className,
  description,
  descriptionVariant,
}: Props) => (
  <Wrapper className={className}>
    <Title asChild>
      <Heading variant="h3-strong">{title}</Heading>
    </Title>
    {description && (
      <Description asChild>
        <Body color={descriptionVariant === "subtle" ? "shade600" : undefined}>
          {description}
        </Body>
      </Description>
    )}
  </Wrapper>
);
